import { CONFERENCE_COLORS } from '@/utils/const';
/**
 * hex转rgb
 * @param {string} str  色值，如：#409EFF
 * @returns rgb数组[64, 158, 255]
 */
export const hexToRgb = str => {
	let hexs = null;
	let reg = /^#[0-9A-Fa-f]{6}$/;
	if (!reg.test(str)) return;

	str = str.replace('#', ''); // 去掉#
	hexs = str.match(/../g); // 切割成数组 409EFF => ['40','9E','FF']
	// 将切割的色值转换为16进制
	for (let i = 0; i < hexs.length; i++) hexs[i] = parseInt(hexs[i], 16);
	return hexs; // 返回rgb色值[64, 158, 255]
};

/**
 * 颜色减淡
 * @param {string} color  色值，如：##409EFF
 * @param {number} level 调整幅度，0~1之间
 * @returns {array} 最终颜色减淡的rgb数组
 */
export const getLightColor = (color, level) => {
	let reg = /^#[0-9A-Fa-f]{6}$/;
	if (!reg.test(color)) return;

	let rgb = hexToRgb(color);
	// 循环对色值进行调整
	for (let i = 0; i < 3; i++) {
		rgb[i] = Math.floor((255 - rgb[i]) * level + rgb[i]); // 始终保持在0-255之间
	}
	return rgb; // [159, 206, 255]
};

/**
 * rgb转hex
 * @param {number} r 红色色值，如：64
 * @param {number} g 绿色色值，如：158
 * @param {number} b 蓝色色值，如：255
 * @returns 最终rgb转hex的值，如：64,158,255 -> #409EFF
 */
export const rgbToHex = (r, g, b) => {
	let reg = /^\d{1,3}$/; // 限定1-3位 -> 0~255
	if (!reg.test(r) || !reg.test(g) || !reg.test(b)) {
		console.warn('色值不正确', r, g, b);
		return;
	}
	let hex = [r.toString(16), g.toString(16), b.toString(16)];
	// 转换的值如果只有一位则补0
	for (let i = 0; i < 3; i++) {
		if (hex[i].length === 1) hex[i] = `0${hex[i]}`;
	}
	return `#${hex.join('')}`; // #409eff
};

/**
 * 将十六进制颜色转换为 rgba 格式
 * @param {string} hex - 十六进制颜色值，例如 "#3964E5"
 * @param {number} [alpha=1] - 透明度值，范围从 0 到 1，默认为 1
 * @returns {string} - rgba 颜色值，例如 "rgba(57, 100, 229, 1)"
 */
function hexToRgba(hex, alpha = 1) {
	// 去掉前面的 '#' 符号
	hex = hex.replace(/^#/, '');

	// 处理三位数的十六进制颜色值
	if (hex.length === 3) {
		hex = hex
			.split('')
			.map(char => char + char)
			.join('');
	}

	// 将十六进制颜色值转换为 RGB 值
	const bigint = parseInt(hex, 16);
	const r = (bigint >> 16) & 255;
	const g = (bigint >> 8) & 255;
	const b = bigint & 255;

	// 返回 rgba 颜色值
	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function changeColor(color, alpha) {
	// color = color || variables['--theme-color'];
	// 需要判断color是否是16进制颜色值,还是rgba颜色值
	let rgba = '';
	if (color.indexOf('rgba') > -1) {
		// 获取默认的透明度值
		const defaultAlpha = color.match(/[^,]+(?=\))/)[0] || 1;
		// 保留两位小数
		const alp = Math.round(defaultAlpha * alpha * 100) / 100;
		rgba = color.replace(/[^,]+(?=\))/, alp);
	} else {
		rgba = hexToRgba(color, alpha);
	}
	return rgba;
}

/**
 * 生成基于基础颜色的颜色数组。
 *
 * 该函数通过逐步降低透明度（alpha 值）来生成一系列颜色，这些颜色基于给定的基础颜色。
 * 这种方法适用于创建颜色梯度或颜色过渡效果。
 *
 * @param {string} baseColor - 基础颜色的字符串表示，通常是十六进制颜色码。
 * @param {number} steps - 颜色变化的步数，默认为 9，表示生成 9 个不同透明度的颜色。
 * @returns {Array} 返回一个包含基于基础颜色和透明度变化的颜色的数组。
 */
export const generateColorArray = (baseColor, steps = 9) => {
	const colors = [];
	for (let i = 0; i < steps; i++) {
		const alpha = (steps - i) / 10; // 计算当前步骤的透明度，从0.9递减至1.0
		const lightColor = getLightColor(baseColor, alpha);
		colors.push(lightColor);
	}
	return colors;
};

// 设置主题色的各种透明度值 设置全局的--theme-rgba-color变量

const THEME_RGBA = [0.05, 0.1, 0.14, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9];

// 0.05 => 005
// 0.1 => 01
// 0.2 => 02

export function setConferenceColor(color, fontColor, dom) {
	color = color || '#3964e5';
	fontColor = fontColor || '#1d2129';
	console.log(999, color, fontColor);
	const root = dom;
	root.style.setProperty(CONFERENCE_COLORS.THEME_COLOR, color);
	root.style.setProperty(CONFERENCE_COLORS.FONT_COLOR, fontColor);
	root.style.setProperty(
		CONFERENCE_COLORS.TITLE_FONT_COLOR,
		fontColor?.toLowerCase() === '#1d2129' || fontColor === 'rgba(29, 33, 41, 1)' ? '#ffffff' : fontColor
	);
	//
	THEME_RGBA.forEach(alpha => {
		const key = alpha.toString().replace('.', '');
		// 需要判断color是否是16进制颜色值,还是rgba颜色值
		root.style.setProperty(`${CONFERENCE_COLORS.THEME_COLOR_RGBA}-${key}`, changeColor(color, alpha));
		root.style.setProperty(`${CONFERENCE_COLORS.FONT_COLOR_RGBA}-${key}`, changeColor(fontColor, alpha));
		root.style.setProperty(
			`${CONFERENCE_COLORS.TITLE_FONT_COLOR_RGBA}-${key}`,
			fontColor?.toLowerCase() === '#1d2129' ? '#fff' : changeColor(fontColor, alpha)
		);
	});
}
